import Button from 'molecules/Button';
import RichText from 'molecules/RichText';

import styles from 'components/SplitContent/splitcontent.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { SplitContentProps } from 'components/SplitContent/config';
import type { ElementType, FC } from 'react';

const SplitContent: FC<SplitContentProps> = ({ heading, callToAction, initialSide, details, detailCallToActions }) => {
  const sectionClassName = heading ? styles.section : '';
  const EyebrowHtmlTag = (initialSide?.eyebrowHtmlTag || 'h3') as ElementType;

  return (
    <section className={sectionClassName}>
      {heading && (
        <div className={styles.heading}>
          <RichText content={heading || ''} />
          {callToAction?.url && <Button {...callToAction} className={styles.darkArrow} />}
        </div>
      )}
      <div className={styles.sideBySideContainer}>
        <div className={styles.initialSideText}>
          {initialSide?.eyebrow && (
            <EyebrowHtmlTag className={styles.title}>{initialSide.eyebrow.replace(/\\n/g, '\n')}</EyebrowHtmlTag>
          )}
          {isNonEmptyArray(initialSide?.callToActions) &&
            initialSide.callToActions.map(cta => (
              <div key={`${cta?.callToAction?.url}`}>
                {cta?.callToAction?.label && (
                  <Button {...cta.callToAction} className={styles.darkArrow} target="_self" />
                )}
              </div>
            ))}
        </div>
        <div className={styles.rightSide}>
          {details && (
            <RichText
              content={details.replace(/\\n/g, '\n').replace(/\\ul/g, '<ul>').replace(/\\cul/g, '</ul>')}
              className={styles.details}
            />
          )}
          {isNonEmptyArray(detailCallToActions) &&
            detailCallToActions.map(cta => (
              <div key={`${cta?.callToAction?.url}`}>
                {cta?.callToAction?.label && (
                  <Button
                    {...cta.callToAction}
                    className={`${cta.callToAction.types === 'arrow' ? styles.darkArrow : styles.button}`}
                    color={`${cta.callToAction.types === 'arrow' ? '' : 'teal'}`}
                    target="_self"
                  />
                )}
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default SplitContent;
